import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "qtl-tag-edit-popover" }
const _hoisted_3 = ["aria-label"]

import { computed, ref } from "vue";
import {
  AnalyticsV2ElementType,
  ColumnCategory,
  TableDataCellDisplayType,
  TagType,
} from "@/models/etc/types";
import type {
  CellDataTagStatus,
  TableDataCell,
} from "@/models/interfaces/entity-settings/querytable/querytable";
import { auxStore } from "@/store/auxillary";
import { generalStore } from "@/store/general";
import { i18n } from "@/i18n";
import MostaContextMenu from "@/components/common/basic/MostaContextMenu.vue";
import MostaSelect from "@/components/common/MostaSelect.vue";

interface TagRow { text: string; color: string; }


export default /*@__PURE__*/_defineComponent({
  __name: 'TagCellElementLite',
  props: {
    element: {},
    entityId: {}
  },
  emits: ["refreshNeeded"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const t = (k: string) => i18n.global.t(k);

const aux = auxStore();
const gstore = generalStore();

function tagStatusName(arg: number): string {
  switch (arg) {
    case TagType.Standard: return t("normal_label");
    case TagType.Hidden: return t("hidden_upcase");
    default: return t("status_unknown");
  }
}

const rows = computed<TagRow[]>(() => {
  return (props.element.Data as CellDataTagStatus[]).map((cell) => {
    switch (cell.Status) {
      case TagType.Hidden:
        return { text: tagStatusName(cell.Status), color: "blue" };
      case TagType.Standard:
      default:
        return { text: tagStatusName(cell.Status), color: "black" };
    }
  });
});

const isTagNameStatus = computed<boolean>(() =>
  props.element.Category === ColumnCategory.Status &&
  props.element.DisplayType === TableDataCellDisplayType.TagStatus &&
  gstore.selectedItem?.DestType === AnalyticsV2ElementType.Tag,
);

const tagStatusOptions = computed(() =>
  Object.values(TagType)
    .filter((v) => !isNaN(Number(v)) && Number(v) >= 0)
    .map((vm) => ({ label: tagStatusName(Number(vm)), value: Number(vm) })),
);

const initialStatus = props.element.Data?.[0]
  ? (props.element.Data[0] as CellDataTagStatus).Status
  : TagType.Standard;
const tempStatus = ref<{ label: string; value: number } | null>(
  { label: tagStatusName(initialStatus), value: initialStatus },
);

const menuOpen = ref(false);
const menuPos = ref<{ top: string; left: string }>({ top: "0px", left: "0px" });
const editBtnRef = ref<HTMLElement | null>(null);

function openEditMenu(ev: MouseEvent) {
  // Поповер держим у нижнего правого угла кнопки
  const rect = editBtnRef.value?.getBoundingClientRect();
  if (rect) {
    menuPos.value = { top: `${rect.bottom + 2}px`, left: `${rect.right - 200}px` };
  } else {
    menuPos.value = { top: `${ev.clientY}px`, left: `${ev.clientX}px` };
  }
  menuOpen.value = true;
}

async function applyChanges() {
  if (!aux || !props.entityId || !tempStatus.value) return;
  if (!isTagNameStatus.value) return;
  const ok = await aux.updateSingleTagStatus({
    TagId: props.entityId,
    NewStatus: tempStatus.value.value,
  });
  if (ok) {
    menuOpen.value = false;
    emit("refreshNeeded");
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (rec, i) => {
      return (_openBlock(), _createElementBlock("span", {
        key: 'tag_' + i,
        class: "qtl-tag-row",
        style: _normalizeStyle({ color: rec.color })
      }, _toDisplayString(rec.text), 5))
    }), 128)),
    (isTagNameStatus.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          ref_key: "editBtnRef",
          ref: editBtnRef,
          class: "qtl-tag-edit-btn",
          type: "button",
          "aria-label": t('edit_label'),
          onClick: _withModifiers(openEditMenu, ["stop"])
        }, _cache[2] || (_cache[2] = [
          _createElementVNode("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 24 24",
            fill: "currentColor"
          }, [
            _createElementVNode("path", { d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" })
          ], -1)
        ]), 8, _hoisted_1))
      : _createCommentVNode("", true),
    (isTagNameStatus.value)
      ? (_openBlock(), _createBlock(MostaContextMenu, {
          key: 1,
          visible: menuOpen.value,
          position: menuPos.value,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (menuOpen.value = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(MostaSelect, {
                class: "qtl-tag-edit-popover__select",
                "model-value": tempStatus.value,
                options: tagStatusOptions.value,
                label: t('status_label'),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = (v) => { tempStatus.value = v })
              }, null, 8, ["model-value", "options", "label"]),
              _createElementVNode("button", {
                type: "button",
                class: "qtl-tag-edit-popover__apply",
                "aria-label": t('apply_changes'),
                onClick: applyChanges
              }, _cache[3] || (_cache[3] = [
                _createElementVNode("svg", {
                  width: "14",
                  height: "14",
                  viewBox: "0 0 24 24",
                  fill: "currentColor"
                }, [
                  _createElementVNode("path", { d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" })
                ], -1)
              ]), 8, _hoisted_3)
            ])
          ]),
          _: 1
        }, 8, ["visible", "position"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})